import { components } from 'react-select';
import { BsSearch } from 'react-icons/bs';
import { createContext } from 'react';

const IntegrationContext = createContext({});


// const engineTypeOptions = [
//   { value: 'Delphix', label: 'Delphix Masking' },
//   // { value: 'ENCRYPT', label: 'Encryption' },
//   // { value: 'REDACT', label: 'Redaction' },
//   // { value: 'SYNTHESIZE', label: 'Synthesis' },
// ]

// const getEngineTypeOptions = (integrations) => {
//   console.log('getEngineTypeOptions', integrations);
//   let availableEngineTypes = {...engineTypeOptions};
//   for (const integration of integrations) {
//     availableEngineTypes = availableEngineTypes.filter((option) => option.value !== integration.enginetype);
//   }
//   return availableEngineTypes;
// }


const Option = ({ children, ...props }) => {
  const data = props.data;
  const value = data && data.value;
  const helperText = `Connect to a ${data.label} engine.`;

  return (
    <components.Option className='position-relative' {...props}>
      <div className='d-flex flex-row'>
        <div className='mr-2'>
          {data && data.icon}
        </div>
        <div>
          <div>
            {children}
          </div>
          { value &&
            <div className='select-box-helper'>
              {helperText}
            </div>
          }
        </div>
      </div>
    </components.Option>
  );
};

const Input = ({ children, ...props }) => {
  const validValue = props.value && props.value.length && props.value.length > 0;

  return (
    <div 
      className='select-box-input-container'
    >
      { validValue > 0 && <BsSearch className='select-box-search-icon'/> }
      <components.Input className='select-box-input' {...props} />
      { validValue > 0 && (
        <div className='select-box-search-helper-text select-box-helper'>
          Filter by data source type.
        </div>
      )}
    </div>
  )
}

const SingleValue = ({ children, ...props }) => {
  const data = props.data;
  const value = data && data.value;
  const helperText =  `Connect to a ${data.label} engine.`;

  return (
    <components.SingleValue className='position-relative d-flex flex-row' {...props}>
      <div className='mr-2'>
        {data && data.icon}
      </div>
      <div>
        <div>
          {children}
        </div>
        { value &&
          <div className='select-box-helper'>
            {helperText}
          </div>
        }
      </div>
    </components.SingleValue>
  )
}



const customFilter = (option, searchText) => {
  const label = option.data && option.data.label && option.data.label.toLowerCase();
  const type = option.value && option.value.type && option.value.type.toLowerCase();
  const database = option.value && option.value.database && option.value.database.toLowerCase();

  const searchTerms = searchText.toLowerCase();
  const searchedByLabel = label && label.includes(searchTerms);
  const searchedByType = type && type.includes(searchTerms);
  const searchedByDatabase = database && database.includes(searchTerms);

  return (searchedByLabel || searchedByType || searchedByDatabase);
}

const getReactSelectOption = (type, options) => (options.find((item) => item.value === type)) || (options[options.length - 1]);

export {
  IntegrationContext,
  customFilter,
  getReactSelectOption,
  Input,
  Option,
  SingleValue,
  // engineTypeOptions,
  // getEngineTypeOptions
}